<template>
  <div class="w-full">
    <div class="md:ml-18 max-w-600 px-6 py-4">
      <div class="text-xl font-medium mb-3 truncate text">{{ title }}</div>
      <div v-if="avator || nickname" class="flex items-center">
        <div class="w-10 h-10 rounded-full overflow-hidden">
          <img :src="avator" class="w-full h-full" />
        </div>
        <span class="ml-2 font-medium text">{{ nickname }}</span>
      </div>
    </div>
    <div class="w-full h-px dashed mx-auto"></div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class ScreenshotUserInfo extends Vue {
  @Prop({ type: String }) title: string;
  @Prop({ type: String }) avator: string;
  @Prop({ type: String }) nickname: string;
}
</script>
<style scoped>
.text {
color: #1A051D;
}
.dashed {
  background-image: linear-gradient(to right, #e2daff 50%, rgba(255, 255, 255, 0) 0%);
  background-repeat: repeat-x;
  background-position: bottom;
  background-size: 12px 1px;
}
</style>
